import React, { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { URL } from '../constants'
import { AuthContext } from '../store/auth-context'
import { logoutApi } from '../services/api/logout'


const Logout = () => {
	const authCtx = useContext(AuthContext)
    const navigate = useNavigate()
    useEffect(() => {
    logoutApi?.getAll?.()
    	.then(response => {
        	authCtx.logout();
        	navigate(URL.signIn);
    	})
    	.catch(err => {
        	console.log(err);
    	})
        
    }, [])

    return (
       null
    )
}

export default Logout
